import React from 'react';

import { usePlatformBillingInformationQuery, WaypointFeatureTier } from '@dashboard/generated/wp/platform';
import { TipsAndUpdatesOutlined } from '@mui/icons-material';
import { Alert, Box, Button, Typography } from '@mui/material';

export default function ExpiredAlert() {
  const { data } = usePlatformBillingInformationQuery();
  const billingInfoModel = data?.PlatformBillingInformation;

  if (billingInfoModel === undefined) {
    return null;
  }

  const renderUpgradeMessage = (tierName: string, period: number) => {
    return (
      <>
        You are currently on our <strong>{tierName} plan</strong> with a message log retention limit of{' '}
        <strong>{period} days</strong>. Upgrade to extend.
      </>
    );
  };

  const renderMessage = () => {
    switch (billingInfoModel.activeWaypointTier) {
      case WaypointFeatureTier.Free:
      case WaypointFeatureTier.Sample:
      case WaypointFeatureTier.Sandbox:
        return renderUpgradeMessage('Free', 7);
      case WaypointFeatureTier.Starter:
        return renderUpgradeMessage('Starter', 7);
      case WaypointFeatureTier.Growth:
        return renderUpgradeMessage('Growth', 14);
      case WaypointFeatureTier.Pro:
      case WaypointFeatureTier.Unlimited:
        return 'Message log retention is unavailable after 1 month.';
    }
  };

  return (
    <Box p={3}>
      <Alert variant="outlined" severity="info" sx={{ py: 2 }} icon={<TipsAndUpdatesOutlined />}>
        <Typography variant="h6" gutterBottom>
          Upgrade to extend message retention
        </Typography>
        <Typography paragraph>{renderMessage()}</Typography>
        <Button size="small" variant="outlined" target="_blank" href="https://www.usewaypoint.com/docs/log-retention">
          Learn more
        </Button>
      </Alert>
    </Box>
  );
}
